import YesNoInput from '@components/input/yes-no.input.jsx';
import CustomizeSection from '@components/overlays/shared/customize-section.jsx';
import PropTypes from 'prop-types';

DevCustomizeOptions.propTypes = {
  config: PropTypes.object,
  setConfigState: PropTypes.func.isRequired,
  children: PropTypes.node,
};
export default function DevCustomizeOptions({
  config,
  setConfigState,
  children,
}) {
  const splitHost = window.location.host.split('.');

  let environment = 'prod';

  if (splitHost.length > 1) {
    const hostEnvironment = splitHost[1];

    switch (hostEnvironment) {
      case 'dev':
      case 'qa':
        environment = hostEnvironment;
        break;
      case 'experience':
        environment = 'prod';
    }
  } else environment = import.meta.env.VITE_APP_ENV;

  const showDonationsOption = Object.prototype.hasOwnProperty.call(
    config,
    'showAllDonations'
  );

  const showDebugOption = Object.prototype.hasOwnProperty.call(
    config,
    'debugMode'
  );

  if (
    environment !== 'dev' ||
    (!showDonationsOption && !showDebugOption && !children)
  )
    return <></>;

  return (
    <div className="user-select-none mb-4">
      <CustomizeSection title="Developer Options">
        {showDonationsOption && (
          <YesNoInput
            currentValue={config.showAllDonations}
            name="showAllDonations"
            onChange={setConfigState}
            mode="checkbox"
            label="Show all donations from campaign"
          />
        )}

        {showDebugOption && (
          <YesNoInput
            currentValue={config.debugMode}
            name="debugMode"
            onChange={setConfigState}
            mode="checkbox"
            label="Enable debug mode"
          />
        )}
        {children}
      </CustomizeSection>
    </div>
  );
}
